(() => {
  const page = document.querySelector('[data-md-case-page]');
  if (!page) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const progress = page.querySelector('.md-case__progress');
  if (progress && !CSS.supports('animation-timeline: scroll()')) {
    let frame = 0;
    const update = () => {
      frame = 0;
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.setProperty('--md-case-progress', max > 0 ? Math.min(1, scrollY / max) : 0);
    };
    addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  const counters = [...page.querySelectorAll('[data-md-count]')];
  if (!counters.length || reduce || !('IntersectionObserver' in window)) return;

  const parse = (text) => {
    const match = text.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/s);
    if (!match) return null;
    const raw = match[2];
    const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
    return { before: match[1], after: match[3], target: parseFloat(raw.replace(/,/g, '')), decimals, grouped: raw.includes(',') };
  };

  const format = (value, spec) => {
    const fixed = value.toFixed(spec.decimals);
    if (!spec.grouped) return fixed;
    const [whole, fraction] = fixed.split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (fraction ? '.' + fraction : '');
  };

  const run = (element) => {
    const spec = element.mdCount;
    const start = performance.now();
    const duration = Math.min(2200, 900 + spec.target * 4);
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 4);
      element.textContent = spec.before + format(spec.target * eased, spec) + spec.after;
      if (t < 1) requestAnimationFrame(step);
      else element.textContent = element.mdCountFinal;
    };
    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      run(entry.target);
    });
  }, { threshold: 0.6 });

  counters.forEach((element) => {
    const text = element.textContent.trim();
    const spec = parse(text);
    if (!spec || spec.target === 0) return;
    element.mdCount = spec;
    element.mdCountFinal = text;
    element.textContent = spec.before + format(0, spec) + spec.after;
    observer.observe(element);
  });
})();
